import { render, staticRenderFns } from "./cs-txVideo.vue?vue&type=template&id=af55a788&scoped=true&"
import script from "./cs-txVideo.vue?vue&type=script&lang=js&"
export * from "./cs-txVideo.vue?vue&type=script&lang=js&"
import style0 from "./cs-txVideo.vue?vue&type=style&index=0&id=af55a788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af55a788",
  null
  
)

export default component.exports